import React from 'react';
import { MapComponent } from '../components/Map/MapComponent';
import { FilterBar, FilterValues } from '../components/Filters/FilterBar';
import { StatsCards } from '../components/Stats/StatsCards';
import { CitiesTable } from '../components/DataTable/CitiesTable';
import { getCidadesByFilters, cidades } from '../data/mockData';
import { fetchCityBoundaries } from '../services/boundariesApi';
import { FilteredDataResponse } from '../services/filtersApi';
import { FeatureCollection } from 'geojson';
import { PageTitle } from "../../../../_metronic/layout/core";

export const SellerMapping: React.FC = () => {
  const [filters, setFilters] = React.useState<FilterValues>({
    unidadeNegocio: 'Todos',
    distribuidor: 'Todos',
    estado: 'Todos',
    municipio: 'Todos',
  });

  const [selectedCities, setSelectedCities] = React.useState<Set<string>>(
    new Set(cidades.map((c:any) => c.id))
  );

  const [boundaries, setBoundaries] = React.useState<any>(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const [filteredData, setFilteredData] = React.useState<FilteredDataResponse | null>(null);
  const [mapCenter, setMapCenter] = React.useState<[number, number] | undefined>(undefined);
  const [mapZoom, setMapZoom] = React.useState<number>(7);

  const filteredCities = getCidadesByFilters(
    filters.unidadeNegocio,
    filters.distribuidor,
    filters.estado
  );

  const visibleCities = filteredCities.filter((c:any) => selectedCities.has(c.id));

  React.useEffect(() => {
    loadBoundaries();
  }, [selectedCities, filters]);

  const loadBoundaries = async () => {
    if (visibleCities.length === 0) {
      setBoundaries(null);
      return;
    }

    setIsLoading(true);
    try {
      const cityNames = visibleCities.map(c => c.nome);
      const data = await fetchCityBoundaries(cityNames);
      setBoundaries(data);
    } catch (error) {
      console.error('Error loading boundaries:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterChange = (newFilters: FilterValues) => {
    setFilters(newFilters);
  };

  const calculateCenter = (features: any[]): [number, number] => {
    if (features.length === 0) return [-19.5, -47.5];

    let totalLat = 0;
    let totalLon = 0;
    let count = 0;

    features.forEach(feature => {
      if (feature.properties && feature.properties.lat && feature.properties.lon) {
        totalLat += feature.properties.lat;
        totalLon += feature.properties.lon;
        count++;
      }
    });

    if (count === 0) return [-19.5, -47.5];

    return [totalLat / count, totalLon / count];
  };

  const handleDataFiltered = (data: FilteredDataResponse) => {
    setFilteredData(data);

    if (data.success && data.data.cities && data.data.cities.length > 0) {
      try {
        const features = data.data.cities.map(city => {
          const parsedGeoJSON = JSON.parse(city.geojson);
          return parsedGeoJSON;
        });

        const featureCollection: FeatureCollection = {
          type: 'FeatureCollection',
          features: features
        };

        setBoundaries(featureCollection);

        const center = calculateCenter(features);
        setMapCenter(center);
        setMapZoom(features.length === 1 ? 10 : 7);
      } catch (error) {
        console.error('Error parsing GeoJSON:', error);
      }
    }
  };

  const handleCityToggle = (cityId: string) => {
    setSelectedCities(prev => {
      const newSet = new Set(prev);
      if (newSet.has(cityId)) {
        newSet.delete(cityId);
      } else {
        newSet.add(cityId);
      }
      return newSet;
    });
  };

  const handleSelectAll = (selected: boolean) => {
    if (selected) {
      setSelectedCities(new Set(filteredCities.map((c:any) => c.id)));
    } else {
      setSelectedCities(new Set());
    }
  };

  return (
    <div className="h-[85vh] flex flex-col bg-gray-50 overflow-hidden">
      <PageTitle>Seller Mapping</PageTitle>
      <div className="flex-shrink-0">
        <FilterBar
          onFilterChange={handleFilterChange}
          onDataFiltered={handleDataFiltered}
        />
      </div>

      {/*<div className="flex-shrink-0">
        <StatsCards
          unidadesNegocio={4}
          distribuidores={11}
          cidadesAtendidas={5}
        />
      </div>*/}

      <div className="flex-1 flex gap-4 p-4 overflow-hidden min-h-0">
        <div className="flex-1 bg-white rounded-lg overflow-hidden relative min-h-0">
          {isLoading && (
            <div className="absolute inset-0 bg-white/80 z-10 flex items-center justify-center">
              <div className="text-gray-800 text-lg font-medium">Carregando fronteiras...</div>
            </div>
          )}
          <MapComponent
            boundaries={boundaries}
            selectedCities={visibleCities}
            center={mapCenter}
            zoom={mapZoom}
          />
        </div>

        {/*<div className="w-80 flex-shrink-0 min-h-0">
          <CitiesTable
            data={filteredCities}
            selectedCities={selectedCities}
            onCityToggle={handleCityToggle}
            onSelectAll={handleSelectAll}
          />
        </div>*/}
      </div>
    </div>
  );
};

export default SellerMapping;